import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createSeoMetaTag = async (data) => {
  try {
    let res = await Api.post("/seo-meta-tag", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getSeoMetaTagData = async (query) => {
  try {
    let res = await Api.get("/seo-meta-tag", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getSeoMetaTagById = async (id) => {
  try {
    let res = await Api.get("/seo-meta-tag/" + id);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const checkSeoMetaTagSlug = async (query) => {
  try {
    let res = await Api.get("/seo-meta-tag/check-slug", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const updateSeoMetaTagData = async (id, data) => {
  try {
    let res = await Api.patch("/seo-meta-tag/" + id, data);
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const deleteSeoMetaTagData = async (id) => {
  try {
    let res = await Api.delete("/seo-meta-tag/" + id);
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
